import React from 'react';
import { array, shape } from 'prop-types';
import { Provider } from 'react-redux';

import configureStore from './redux/configureStore';
import PartnerSubmissionFormContainer from './PartnerSubmissionFormContainer';

import { categoryOptions } from './utils';

export default function PartnerSubmissionApp({ meta: { partner }, meta }) {
  const hasSelectedCategory =
    partner && partner.category_ids && partner.category_ids.length > 0;
  const selectedCategory = hasSelectedCategory
    ? categoryOptions.find((option) => option.value === partner.category_ids[0])
    : {};

  const preloadedState = {
    meta: {
      ...meta,
      isDuplicatePartner: false
    },
    ui: {
      activePage: 1,
      selectedCategory,
      showModal: false
    }
  };

  return (
    <Provider store={configureStore(preloadedState)}>
      <PartnerSubmissionFormContainer />
    </Provider>
  );
}

PartnerSubmissionApp.propTypes = {
  meta: shape({
    countryOptions: array.isRequired,
    entityTypeOptions: array.isRequired,
    leadGenerationMethodOptions: array.isRequired,
    referralOptions: array.isRequired,
    serviceCountryOptions: array.isRequired,
    stateOptions: array.isRequired
  }).isRequired
};
